export default __webpack_public_path__ + "static/media/kwiaty.ab0b532f.svg";